import { Outlet } from 'react-router';

import { useBoysenberrySignupFlag } from 'hooks/useFeatureFlag/useBoysenberrySignupFlag';

export default function AccountCreationLayout() {
    const { isReady: splitIsReady, treatment } = useBoysenberrySignupFlag();

    return (
        <main className="mx-auto flex max-w-screen-md flex-col p-25">
            {splitIsReady && <Outlet context={{ treatment }} />}
        </main>
    );
}
